import createReducer from '../../utils/createReducer';
import trendingCorridorDestinationsHandlers from './trendingCorridorDestinations';
import recommendedPropertiesHandlers from './recommendedProperties';
import trustpilotHandlers from './trustpilot';

const initialState = {
  header: {},
  jumbotron: {},
  footer: {},
  searchbox: {}
};

export default createReducer(initialState, {
  ...trendingCorridorDestinationsHandlers,
  ...trustpilotHandlers,
  ...recommendedPropertiesHandlers
});
